<template>
    <div id="app" :class="[$store.state.isfull?'appfull':'appnormal']">
        <Cheader v-show="isshowheaderfooter" :collegeid="collegeid"></Cheader>
        <router-view @showheaderfooter="showheaderfooter" @setcollegeid="setcollegeid" @hidepop="hidepop" />
        <Cfooter v-show="isshowheaderfooter"></Cfooter>
    </div>
</template>

<script>

    import Cheader from '@/components/Cheader';
    import Cfooter from '@/components/Cfooter';

    export default {
        name: 'app',
        data() {
            return {
                'isshowheaderfooter': true,
                'topnavsort': 0,
                'collegeid': 0,
                'isshowpop': false,
                'popurl': '',
                'poptype': 1,
                'isfull': false
            }
        },
        components: {
            Cheader,
            Cfooter
        },
        /*created() {
            this.$store.dispatch('setlangdic');//异步加载字典
        },*/
        methods: {
            showheaderfooter(v) {
                this.isshowheaderfooter = v;
            },
            setcollegeid(v) {
                this.collegeid = v;
            },
            showpop() {
                this.isshowpop = true;
            },
            hidepop() {
                this.isshowpop = false;
            }
        },
        mounted() {//阻止#链接
            let aprevent = (e, href) => {

                href = this.$common.basic.chempty(href) ? "" : href.substring(href.length - 1)
                if (href == "#") {
                    if (e.preventDefault) {
                        e.preventDefault();
                    } else {
                        e.returnValue = false;
                    }
                    //return false;
                }
            };

            document.addEventListener('click', (e) => {
                if (e.target.tagName === 'A') {
                    aprevent(e, e.target.href);
                }
                else {
                    if (e.target.parentNode.tagName === 'A') {
                        aprevent(e, e.target.parentNode.href);
                    }
                }
            });


            window.onresize = () => {
                this.$store.commit('SET_WINDOWSIZE');
            }

        }
    };
</script>
